export default function StatementIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_235_581)">
        <path
          d="M16.68 1.66669C15.7522 1.66669 15 3.90526 15 6.66669H16.68C17.4897 6.66669 17.8945 6.66669 18.1451 6.38715C18.3958 6.1076 18.3521 5.73946 18.2648 5.0032C18.0345 3.05955 17.4119 1.66669 16.68 1.66669Z"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M14.9998 6.7119V15.5382C14.9998 16.7979 14.9998 17.4278 14.6148 17.6757C13.9858 18.0809 13.0133 17.2312 12.5241 16.9228C12.1199 16.6679 11.9179 16.5404 11.6936 16.5331C11.4513 16.5251 11.2456 16.6474 10.8089 16.9228L9.2165 17.927C8.78692 18.1979 8.57217 18.3334 8.33317 18.3334C8.09418 18.3334 7.87939 18.1979 7.44984 17.927L5.85745 16.9228C5.4533 16.6679 5.25122 16.5404 5.02695 16.5331C4.7846 16.5251 4.57895 16.6474 4.14223 16.9228C3.65313 17.2312 2.68056 18.0809 2.05146 17.6757C1.6665 17.4278 1.6665 16.7979 1.6665 15.5382V6.7119C1.6665 4.33356 1.6665 3.1444 2.39874 2.40555C3.13097 1.66669 4.30948 1.66669 6.6665 1.66669H16.6665"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 5H11.6667"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66667 8.33331H5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4165 9.06248C9.72617 9.06248 9.1665 9.55215 9.1665 10.1562C9.1665 10.7603 9.72617 11.25 10.4165 11.25C11.1068 11.25 11.6665 11.7396 11.6665 12.3437C11.6665 12.9478 11.1068 13.4375 10.4165 13.4375M10.4165 9.06248C10.9608 9.06248 11.4238 9.36681 11.5953 9.79165M10.4165 9.06248V8.33331M10.4165 13.4375C9.87225 13.4375 9.40925 13.1331 9.23767 12.7083M10.4165 13.4375V14.1666"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_235_581">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
